import { useEffect, useRef } from "react";

export const CursorEffect = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let ringX = mouseX;
    let ringY = mouseY;
    let isHovering = false;
    let animId;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const handleMouseOver = (e) => {
      const target = e.target;
      if (
        target.closest('a, button, [role="button"], input, select, textarea, label')
      ) {
        isHovering = true;
      } else {
        isHovering = false;
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseover", handleMouseOver);

    const animate = () => {
      if (dotRef.current) {
        dotRef.current.style.left = `${mouseX}px`;
        dotRef.current.style.top = `${mouseY}px`;
      }

      ringX += (mouseX - ringX) * 0.14;
      ringY += (mouseY - ringY) * 0.14;

      if (ringRef.current) {
        ringRef.current.style.left = `${ringX}px`;
        ringRef.current.style.top = `${ringY}px`;

        if (isHovering) {
          ringRef.current.style.width = "44px";
          ringRef.current.style.height = "44px";
          ringRef.current.style.borderColor = "hsl(68 100% 50% / 0.9)";
          ringRef.current.style.backgroundColor = "hsl(68 100% 50% / 0.07)";
        } else {
          ringRef.current.style.width = "30px";
          ringRef.current.style.height = "30px";
          ringRef.current.style.borderColor = "hsl(68 100% 50% / 0.4)";
          ringRef.current.style.backgroundColor = "transparent";
        }
      }

      animId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(animId);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  return (
    <>
      <div
        ref={ringRef}
        style={{
          position: "fixed",
          pointerEvents: "none",
          zIndex: 9998,
          borderRadius: "50%",
          border: "1.5px solid hsl(68 100% 50% / 0.4)",
          width: "30px",
          height: "30px",
          transform: "translate(-50%, -50%)",
          transition: "width 0.2s ease, height 0.2s ease, border-color 0.2s ease, background-color 0.2s ease",
          top: 0,
          left: 0,
          mixBlendMode: "normal",
        }}
      />
      <div
        ref={dotRef}
        style={{
          position: "fixed",
          pointerEvents: "none",
          zIndex: 9999,
          borderRadius: "50%",
          width: "5px",
          height: "5px",
          backgroundColor: "hsl(68 100% 50%)",
          transform: "translate(-50%, -50%)",
          top: 0,
          left: 0,
        }}
      />
    </>
  );
};

export default CursorEffect;
